import { render, staticRenderFns } from "./CriminalFileEditor.vue?vue&type=template&id=0f3fe0de&"
import script from "./CriminalFileEditor.vue?vue&type=script&lang=js&"
export * from "./CriminalFileEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports